
<template>  
  <button class="button" :disabled="!!stateClass" :class="stateClass" v-on="$listeners">
    <span class="button__content">
      <slot></slot>
    </span>
    <span class="button__progress"></span>
  </button>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'AsyncButton',
  props: {
    promise: {
      type: Promise
    }
  },
  data () {
    return {
      stateClass: ''
    }
  },
  watch: {
    promise (n, o) {
      if (!(n instanceof Promise) || n === o) return

      this.stateClass = 'button--state-loading'
      this.promise
        .then((r) => {
          this.stateClass = 'button--state-success'
          return r
        })
        .catch((e) => {
          this.stateClass = 'button--state-error'
          return e
        })
        .then((r) => { // finally()
          window.setTimeout(() => this.stateClass = '', 2100) // reset to original state
          return r
        })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
